var map = {
	"./en-glossaryItems.js": [
		2626,
		245
	],
	"./es-glossaryItems.js": [
		1138,
		138
	],
	"./fr-glossaryItems.js": [
		8590,
		590
	],
	"./it-glossaryItems.js": [
		7827,
		827
	],
	"./pt-glossaryItems.js": [
		7978,
		978
	],
	"./tr-glossaryItems.js": [
		3572,
		572
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6959;
module.exports = webpackAsyncContext;